export const isDev = process.env.NODE_ENV === 'development';
export const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  (isDev ? 'http://localhost:5001/api' : 'https://backend-production-9dc3.up.railway.app/api');